const MouseZoomIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="8"
    height="12"
    viewBox="0 0 8 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.58649 7.71414H7.06805V7.71181C7.43059 7.71181 7.62941 7.24534 7.36042 6.98282L0.70865 0.1269C0.465429 -0.142631 0 0.0448687 0 0.429298V10.501C0 10.8667 0.437287 11.08 0.706275 10.8011L2.7341 8.71261L3.97615 11.7386C4.06734 11.9519 4.30581 12.0597 4.52107 11.966L5.67176 11.4644C5.87752 11.3706 5.98278 11.1221 5.89159 10.9018L4.58649 7.71414Z"
      fill="white"
    />
    <path
      d="M6.63058 1.31626H7.55175C7.80082 1.31626 7.97497 1.48687 8 1.73063V2.41315C8 2.65686 7.82567 2.82752 7.5766 2.82752H6.65543V3.72936C6.65543 3.97312 6.4811 4.14377 6.23221 4.14377H5.51022C5.26115 4.14377 5.08682 3.97312 5.08682 3.72936V2.82752H4.16565C3.91676 2.82752 3.74243 2.65686 3.74243 2.41315V1.73063C3.74243 1.48687 3.91676 1.31626 4.16565 1.31626H5.08682V0.414375C5.08682 0.170616 5.26115 7.90086e-06 5.51022 7.90086e-06H6.20736C6.45625 7.90086e-06 6.63058 0.170616 6.63058 0.414375V1.31626Z"
      fill="white"
    />
  </svg>
);

export default MouseZoomIcon;
